import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getLabMember(labId: number, fetch: Fetch) {
    return fetch(
        `/lab-member/me?lab=${labId}`,
        { method: 'GET' },
        schemas.LabMemberResponse
    );
}

export const useLabMemberQuery = (labId: number | undefined) => {
    return useQuery({
        queryKey: ['labMember', labId],
        enabled: !!labId,
        retry: false,
        networkMode: 'always',
        queryFn: async () => {
            if (!labId) {
                return null
            }
            return getLabMember(labId, fetch);
        }
    });
};
